/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Landing_Studio_ExampleInputs */

const en_landing_studio_example = /** @type {(inputs: Landing_Studio_ExampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Example ${i?.n}`)
};

const zh_landing_studio_example = /** @type {(inputs: Landing_Studio_ExampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`示例 ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Example {n}" |
*
* @param {Landing_Studio_ExampleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_example = /** @type {((inputs: Landing_Studio_ExampleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_ExampleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_example(inputs)
	return zh_landing_studio_example(inputs)
});
export { landing_studio_example as "landing.studio.example" }